import { Injectable } from '@angular/core';
import { equalTo, orderByChild } from '@angular/fire/database';
import { Recipe } from '../models';
import { DatabaseService } from './database.service';
import { StorageService } from './storage.service';


@Injectable({
  providedIn: 'root'
})
export class RecipeService {

  constructor(
    private dbService: DatabaseService,
    private storageService: StorageService,
  ) { }

  async getRecipeAsPromise(recipeId: string): Promise<Recipe> {
    const snap = await this.dbService.getSnapshot(`allRecipes/${recipeId}`);
    return snap? new Recipe({
      uid: recipeId,
      ...snap
    }) : null;
  }
  
  async getPublicRecipesAsPromise(): Promise<Recipe[]> {
    const snap = await this.dbService.getSnapshot(`allRecipes`, orderByChild("organization"), equalTo("elite-trainr-library"));
    return snap? this.transformFirebaseObjectToArray(snap) : null;
  }

  async getRecipesAsPromise(organizationId: string): Promise<Recipe[]> {
    const snap = await this.dbService.getSnapshot(`allRecipes`, orderByChild("organization"), equalTo(organizationId));
    return snap? this.transformFirebaseObjectToArray(snap) : null;
  }

  async getUserRecipesAsPromise(userId: string): Promise<Recipe[]> {
    const snap = await this.dbService.getSnapshot(`allRecipes`, orderByChild("createdBy"), equalTo(userId));
    return snap? this.transformFirebaseObjectToArray(snap) : null;
  }

  private transformFirebaseObjectToArray(obj) {
    let results = []
    for (const id in obj) {
      if (obj.hasOwnProperty(id)) {
        let item = obj[id];
        item.uid = id;
        results.push(new Recipe(item));
      }
    }
    return results
  }

  async addRecipe(recipeData: Partial<Recipe>, createdBy: string) {
    let recipes = {
      ...recipeData,
      createdBy: createdBy,
      creationDate: new Date().toISOString(),       
      status:'active'
    }
    return this.dbService.pushByRef(`allRecipes`, recipes);
  }
  
  updateRecipe(recipeId: string, data: Partial<Recipe>) {  
    return this.dbService.updateRef(`allRecipes/${recipeId}`, data)  
  }

  async addRecipePicture(imageData: string, recipeId: string): Promise<string> {
    const downloadURL = await this.storageService.fbPutString(`recipes/${recipeId}/photo`, imageData);
    await this.updateRecipe(recipeId, {photo: downloadURL});
    return downloadURL
  } 
}
